import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentModalActiveSurvey = styled.div`
  position: relative;
  top: 3.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 8px;
  min-height: 16em;
  max-height: 32em;
  height: fit-content;
  width: 570px;
  max-width: 600px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0.4em;
  }

  &::-webkit-scrollbar-thumb {
    background: #0008ff85;
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
  .save-mood {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3em;
    .save-mood_info {
      text-align: start;
      margin-left: 18px;
    }
  }
  @media only screen and (max-width: 768px) {
    min-width: 100vw;
    min-height: 100vh;
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
  }
  .content-request-button {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    position: absolute;
    bottom: 6%;
  }
  .view-request-button {
    background: none;
    border: none;
    color: black;
    text-decoration: underline;
    color: ${({ theme }) => theme.primary.purple};
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 6px;
  }
  .mood-meter_disabled {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const GeneralContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  top: 3.64%;
  @media only screen and (max-width: 768px) {
    top: 0;
  }
  .arrow-up {
    width: 0;
    height: 0;
    border-left: 1.2rem solid transparent;
    border-right: 1.3rem solid transparent;
    border-bottom: 2rem solid ${({ theme }) => theme.neutral.white};
  }
`;

export const CloseModalActiveSurvey = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 3px 10px;
  font-weight: 600;
  cursor: pointer;
  justify-content: space-between;
  border-radius: 4px;
  min-height: 33px;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
  .align-right {
    padding: 0px 4px;
  }
  .close {
    position: absolute;
    right: 1%;
  }
`;
// border: 2px solid white;
export const SendFeeling = styled.button`
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  /*float: right;*/
  width: 20%;
  height: 40px;
  margin: 0% 40% 1vw 40%;
  text-align: center;
  color: white;

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`;

export const MoodmeterTabSwitch = styled.div`
  display: flex;
  height: 20px;
  width: 90%;
  margin: 3% 5%;
  justify-content: center;
  align-items: center;
  .inline-hr {
    display: inline-block;
    width: 28%;
    border: 1px solid ${({ theme }) => theme.primary.purple};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
export const ModalFooter = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
`;

export const CloseIconSvg = styled.div`
  svg {
    width: 15px;
    height: 15px;
  }
`;

export const SaveMoodSvg = styled.div`
  svg {
    width: auto;
    height: auto;
  }
`;
